import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./InternshipProgram.css";

// ✅ PNG imports as URL
import ArrowRight from "../../assets/developementservices/arrow-right.svg";

import UiImage from "../../assets/developementservices/ui-image.png";
import UiIcon from "../../assets/developementservices/icon-pencil.svg";

import MobileImage from "../../assets/developementservices/mobile-image.png";
import MobileIcon from "../../assets/developementservices/icon-mobile.svg";

import WebImage from "../../assets/developementservices/web-image.png";
import WebIcon from "../../assets/developementservices/icon-web.svg";

import CustomImage from "../../assets/developementservices/custom-image.png";
import CustomIcon from "../../assets/developementservices/icon-custom.svg";

import HrImage from "../../assets/developementservices/hr-image.png";
import HrIcon from "../../assets/developementservices/icon-hr.svg";

import MarketingImage from "../../assets/developementservices/marketing-image.png";
import MarketingIcon from "../../assets/developementservices/icon-marketing.svg";

import InternshipPromo from "../../assets/developementservices/internship-promo.png";
import { AnimatedButton } from "../common/AnimatedButton";
import { motion } from "framer-motion";

const InternshipProgram = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  const internships = [
    {
      title: "UI/UX Design",
      image: UiImage,
      icon: UiIcon,
      description:
        "Learn User Research, Wireframing, Prototyping, and design tools such as Figma. Gain real-world creativity and collaboration experience.",
    },
    {
      title: "Mobile App Development",
      image: MobileImage,
      icon: MobileIcon,
      description:
        "Build apps using React Native or Flutter and work on real-world mobile app projects across platforms.",
    },
    {
      title: "Website Development",
      image: WebImage,
      icon: WebIcon,
      description:
        "Get hands-on with HTML, CSS, JavaScript, and frameworks like React to build modern web apps.",
    },
    {
      title: "Custom App Development",
      image: CustomImage,
      icon: CustomIcon,
      description:
        "Work on custom solutions using advanced tech stacks and solve real business problems.",
    },
    {
      title: "Human Resources (HR)",
      image: HrImage,
      icon: HrIcon,
      description:
        "Learn recruitment, onboarding, and employee engagement while supporting people operations.",
    },
    {
      title: "Digital Marketing",
      image: MarketingImage,
      icon: MarketingIcon,
      description:
        "Gain experience in SEO, content marketing, and running social media campaigns.",
    },
  ];

  const { image, icon, description } = internships[activeIndex];

  return (
    <div>
      {/* Hero Section */}
      <section className="internship-hero-section">
        <div className="internship-hero-content">
          <h1>
            Intern Today, Lead Tomorrow. Join{" "}
            <span className="highlight-script">Our Program</span>
          </h1>
          <p>
            To develop hands-on experience, enhance your technical skills, and
            ensure a bright career in the IT sector.
          </p>
          {/* <Link
            to="/internshipapplication"
            className="internship-apply-now-btn"
          >
            <span className="btn-text">Apply Now</span>
            <span className="btn-circle">
              
              <img
                src={ArrowRight}
                alt="Arrow Icon"
                className="internship-arrow-icon"
              />
            </span>
          </Link> */}
          <AnimatedButton link="/internshipapplication" label="Apply Now" />
        </div>
      </section>

      {/* Internship Positions Section */}
      <section className="internship-internship-section">
        <div className="internship-internship-content">
          {/* Left: Image + Description */}
          <div className="internship-left">
            <img
              src={image}
              alt="Internship Visual"
              className="internship-image"
            />
            <div className="internship-description">
              <img src={icon} alt="Icon" className="internship-icon" />
              <p>{description}</p>
            </div>
          </div>

          {/* Right: List */}
          <div className="internship-right">
            <h2>
              Internship Positions <br /> We Offer
            </h2>
            <p>From classroom to career, let’s make your skills shine.</p>
            <ul className="internship-list">
              {internships.map((item, index) => (
                <motion.div
                  initial={{ opacity: 0, y: 100 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8 }}
                  viewport={{ once: true }}
                >
                  <li
                    key={index}
                    className={index === activeIndex ? "internship-active" : ""}
                    onClick={() => setActiveIndex(index)}
                  >
                    {item.title}
                  </li>
                </motion.div>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Internship Types Section */}

      <section className="internship-types-section">
        <div className="internship-types-container">
          <h2
            className="internship-types-heading"
            style={{ marginBottom: "30px" }}
          >
            Types of Internships{" "}
            <span className="internship-highlight">We Provide</span>
          </h2>
          <p className="internship-types-subtitle">
            Opportunities that fit your journey, from short-term learning to
            full-time career beginnings.
          </p>

          <div className="internship-types-grid">
            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="internship-type-card">
                <h3>
                  Summer <br /> Internship
                </h3>
                <hr />
                <p>
                  Short-term internship taken during summer breaks. Perfect for
                  students who wish to utilize their holiday in getting industry
                  exposure.
                </p>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="internship-type-card">
                <h3>
                  Semester <br /> Internship
                </h3>
                <hr />
                <p>
                  Regular part-time internship during the academic semester.
                  Intended to coincide with college classes while acquiring work
                  experience.
                </p>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="internship-type-card">
                <h3>
                  Full-Time <br /> Internship
                </h3>
                <hr />
                <p>
                  More in-depth internship for final-year students or recent
                  graduates seeking full-time work experience.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Learning Objectives Section */}
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      ></motion.div>
      <section className="internship-learning-section">
        <div className="internship-learning-header">
          <h2>Internship Categories Based on Learning Objectives</h2>
          {/* <p>
            At WebBunny Development, We Empower Brands Through Technology,
            People & Digital Growth.
          </p> */}
        </div>

        <div className="internship-learning-grid">
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="internship-learning-row">
              <div className="internship-learning-number">01</div>
              <div className="internship-learning-title">
                Training Internship
              </div>
              <div className="internship-learning-description">
                Emphasizes technical skill acquisition through formal education,
                guided exercises, and mentoring.
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="internship-learning-row">
              <div className="internship-learning-number">02</div>
              <div className="internship-learning-title">
                Project-Based Internship
              </div>
              <div className="internship-learning-description">
                Collaborate on real-world industry projects, work through
                project lifecycles, and develop hands-on skills in resolving
                real business issues.
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="internship-learning-row">
              <div className="internship-learning-number">03</div>
              <div className="internship-learning-title">
                Academic Internship
              </div>
              <div className="internship-learning-description">
                Specifically for students required to do an internship as part
                of their course of study, with proper paperwork and assessments.
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="internship-advantages-section">
        <div className="internship-advantages-container">
          <h2
            className="internship-advantages-heading"
            style={{ marginBottom: "30px" }}
          >
            Advantages of Joining Our Internship Program
          </h2>
          {/* <p className="internship-advantages-subtitle">
            At WebBunny Development, we empower bands through Technology,
            People & Digital Growth.
          </p> */}

          <div className="internship-advantages-grid">
            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="internship-advantage-card">
                🌍 Real-World Projects
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="internship-advantage-card">
                🎓 Expert Mentorship
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="internship-advantage-card">
                🌟 Portfolio Development
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="internship-advantage-card">
                📈 Skill Enhancement
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="internship-advantage-card">
                🚀 Career Advancement
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="internship-advantage-card">
                📄 Certificate & Recommendation
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Future Desk Promo Section */}
      <section className="internship-future-desk-section">
        <div className="internship-future-desk-container">
          <div className="internship-future-desk-text">
            <h2>Your Future Desk is Waiting!</h2>
            <p>Code, Collaborate, and Innovate in a Real Tech Environment.</p>
            <button
              className="internship-future-desk-button"
              onClick={() => navigate("/contact")}
            >
              Book Your Seat Now
            </button>
          </div>

          <div className="internship-future-desk-illustration">
            <img src={InternshipPromo} alt="Internship Promo" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default InternshipProgram;
